import { _pick } from "../utils/setting";
const application = {
  state: {
    snackbar: {
      open: false,
      content: "",
      type: "success",
    },
  },
  reducers: {
    changeSnackbar(state, payload) {
      state.snackbar = {
        open: false,
        content: "",
        type: "success",
        ...payload,
      };
      return { ...state };
    },
  },
  effects: (dispatch) => ({}),
};

export default application;
